<template>
  <q-page class="server-error">
    <div class="server-error__content">
      <img src="@/assets/flashy_logo_HD.svg" class="server-error__logo" alt="Flashy logo" />

      <!-- SVG Robot Icon -->
      <div class="server-error__icon">
        <img src="@/assets/flashy_error.svg" alt="Error icon" />
      </div>

      <h1 class="server-error__title">Something's not working quite right.</h1>

      <p class="server-error__description">
        Looks like there's a hiccup on our end. We're on it!<br />
        In the meantime, you can head back home and keep creating with Flashy. We'll be back to normal soon.
      </p>

      <q-btn flat class="server-error__button" no-caps @click="goToHome">
        <q-icon name="arrow_back" class="q-mr-sm" />
        Back to homepage
      </q-btn>
    </div>
  </q-page>
</template>

<script>
export default {
  name: 'ServerError',
  methods: {
    goToHome() {
      this.$router.push({ name: 'home' });
    }
  }
};
</script>

<style lang="scss" scoped>
.server-error {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  background-color: var(--main-bg-color);

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    max-width: 600px;
    padding: 0 24px;

    @media (max-width: 768px) {
      padding: 0 32px;
      max-width: 100%;
    }

    @media (max-width: 480px) {
      padding: 0 16px;
      justify-content: flex-start;
      padding-top: 60px;
    }
  }

  &__logo {
    height: 40px;
    margin-bottom: 40px;

    @media (max-width: 768px) {
      margin-bottom: 32px;
    }

    @media (max-width: 480px) {
      height: 32px;
      margin-bottom: 24px;
    }
  }

  &__icon {
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 0;
    font-size: 0;
    overflow: hidden;
    width: 100%;

    @media (max-width: 768px) {
      margin-bottom: 20px;
    }

    @media (max-width: 480px) {
      margin-bottom: 16px;
    }
  }

  &__icon img {
    width: 180px;
    height: auto;
    display: block;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    transform: translateZ(0) scale(1);
    will-change: transform;
    pointer-events: none;

    @media (max-width: 768px) {
      width: 120px;
    }

    @media (max-width: 480px) {
      width: 100px;
    }
  }

  &__title {
    @include inter-font($size: 32px, $bolded: true, $color: var(--main-text-color));
    margin-bottom: 16px;
    line-height: 1.2;

    @media (max-width: 768px) {
      font-size: 28px;
    }

    @media (max-width: 480px) {
      font-size: 24px;
    }
  }

  &__description {
    font-size: 18px;
    line-height: 1.5;
    color: var(--secondary-text-color);
    margin-bottom: 32px;

    @media (max-width: 768px) {
      font-size: 16px;
      margin-bottom: 24px;
    }

    @media (max-width: 480px) {
      font-size: 14px;
      margin-bottom: 20px;
      br {
        display: none;
      }
    }
  }

  &__button {
    background-color: var(--main-btn-color);
    @include inter-font($size: 18px, $bolded: true, $color: var(--main-text-color));
    border-radius: 8px;
    padding: 12px 24px;

    @media (max-width: 480px) {
      font-size: 14px;
      padding: 10px 20px;
    }

    &:deep(.q-btn__content) {
      padding: 8px 16px;
    }
  }
}
</style>
